const routers = {	
	home:{
		redirect:'home',
		file:'home/index',		
		title:'首页',		
		sub:{
			home:{
				show_footer: true,
				title:'首页'
			},			
			schedules:'课表',
			schedule_detail: {
				path: 'schedules/:id',
				file: 'home/schedule/detail',
				title: '排课详情'
			},
			attendances: '考勤',
			attendances_detail: {
				path: 'attendances/:id',
				file: 'home/attendances/detail',
				title: '考勤详情'
			},
			reviews: '课评',	
            reviews_share: {
				path: 'reviews/:id',
				file: 'home/reviews/share',
                public: true,
				title: '课评详情'
			},			
			news:'通知',
			homework:'我的作业',
			homework_detail: {
				path: 'homework/:id',
				file: 'home/homework/detail',
				title: '作业详情'
			},
			homecomplete_detail: {
				path: 'homecomplete/:id',
				file: 'home/homecomplete/detail',
				title: '作业详情',
				public: true,
				show_share: true
			},
			homework_submit: {
				path: 'homework/:id/submit',
				file: 'home/homework/submit',
				title: '作业提交'
			},
			artwork: '我的作品',
			artwork_detail: {
				path: 'artwork/:id',
				file: 'home/artwork/detail',
				title: '作品详情',
				public: true,
				show_share: true
			},
			prepare: '课前预习',
			prepare_detail: {
				path: 'prepare/:id',
				file: 'home/prepare/detail',				
				title: '备课详情'
			},
			book: '图书馆',
			book_detail: {
				path: 'book/:id',
				file: 'home/book/detail',
				title: '图书详情'
			},
			book_center: {
				path: 'bookcenter',
				file: 'home/book/center',
				title: '借阅中心'
			},
            scores:'成绩',
            scores_detail: {
				path: 'scores/:id',
				file: 'home/scores/detail',
				title: '成绩详情'
			}
		}
	},
	lesson: {
		redirect: 'lesson',
		file: 'lesson/index',
		title: '课程',		
		sub: {
			lesson: {
				file: 'lesson/lesson',
				title: '教学',
				show_footer: true
			},
			mylesson: '我的课程',
			class: '我的班级',
			appointment: '预约补课',
			appointment2: '预约活动课',
			add_appointment: '预约补课'
		}
	},	
	growth: {
		title: '成长',
		file: 'growth/index',
		redirect: 'growth/growth',
		sub: {
			growth: {
				title: '成长',
				file: 'growth/growth',
				show_footer: true
			},
			contrast: '成长对比',
			file_record: '成长关注',
			service: '服务记录',
			service_detail: {
				path: 'service/:id',
				file: 'growth/service/detail',
				title: '服务详情'
			},
			growth_archive: '成长档案',
		}
	},
	my: {
		redirect: 'my',
		file: 'my/index',
		title: '我的',
		sub: {
			my: {
				title:'我的',
				show_footer: true
			},
			archives: {
				title: '我的档案',
				show_footer: true
			},
			card: '会员卡',
			card_detail: {
				path: 'card/:id',
				file: 'my/card/detail',
				title: '会员卡详情'
			},
			card_history: {
				path: 'cardhistory/:id',
				file: 'my/card/history',
				title: '历史记录'
			},
			facereg: '人脸注册',
			add: '添加档案',
			message: '我的消息',
			score: '我的成绩',
			wallet: '电子钱包',
			credit: '我的积分',
			orders: '我的订单',
			order_detail:{
				path: 'orders/:id',
				file: 'my/order/detail',
				title: '订单详情'
			},
			payments: '缴费记录',
			complaints: '投诉建议',
			complaints_record: '历史投诉记录',
			setting: '设置',
			recommend_form: '我要推荐',
            recommend_record: '推荐记录',
            media: '我的文件'
		}
	}		
}

export default {
	login:{
		sync:true,
		public:true,
		title:'登录'
	},
	logout:{
		sync:true,
		public:true,
		title:'退出登录'
	},
	forgotpwd:{
		sync:true,
		public:true,
		title:'忘记密码'
	},
	register: {
		sync:true,
		public:true,
		title:'注册'
	},
	tklogin:{
		sync:true,
		public:true,
		title:'自动登录'
	},
	apage:{
		sync:true,
		public:true,
		title:'正在跳转'
	},
	wxtoken: {
		sync: true,
		public:true,
		title:''
	},
	signup: {
		sync: true,
		public: true,
		show_share: true,
		title: '报名信息登记'
	},
	comment: {
		path: '/reviews/:id',
		sync:true,
		public:true,
		show_share: true,
		title:'课评详情'
	},
	scomment: {
		path: '/style-reviews/:id',
		sync:true,
		public:true,
		title:'专业课评单'
	},
    scomment2: {
		path: '/style-reviews2/:id',
		sync:true,
		public:true,
		title:'课评详情'
	},
	fp: {
		path: '/fp/:id',
		sync:true,
		public:true,
		show_share:true,
		title:'文件包'
	},
	sq: {
		path: '/sq/:id',
		sync:true,
		public:true,
		show_share:true,
		title:'学情服务'
	},
	recommend: {
		sync:true,
		public:true,
		show_share:true,
		title:'推荐有奖'
	},
	lessonmap: {
		sync:true,
		public:true,
		show_share:true,
		title:'课程导航'
	},
	contrastdetail: {
		path:'/growth_contrast/:id',
		sync:true,
		public:true,
		title:'成长对比详情'
	},
	teacherintroduce:{
		path: '/teacher/:id',
		sync:true,
		public:true,
		show_share: true,
		title:'教师详情'
	},
	newsdetail:{
		path: '/news/:id',
		sync:true,
		public:true,
		title:'通知详情'
	},
	appforgetpwd:{
		sync:true,
		public:true,
		show_share:true,
		title:'忘记密码'
	},
	root:{
		path:'/',
		redirect:'/home/home',
		title:'首页',
		file:'layout',
		sub:routers
	}	
}


// WEBPACK FOOTER //
// ./src/router.config.js